import type { FC } from "react"

import DisplayAS400Id from "@/components/common/DisplayAS400Id/DisplayAS400Id"
import type { Order } from "@/graphql/codegen/graphql"

interface PurchaseOrderNumberCellProps {
  order: Order
}

export const PurchaseOrderNumberCell: FC<PurchaseOrderNumberCellProps> = ({ order }) => {
  return (
    <div className='flex flex-col items-start gap-1'>
      <div data-testid='purchase-order-number'>{order.orderId}</div>
      <DisplayAS400Id id={order.as400OrderNumber} data-testid='purchase-order-as400-number' />
    </div>
  )
}
